import CountryPickerSkeleton from '@components/country-picker-skeleton';
import { useCountries } from '@hooks/use-countries';
import { Check } from 'lucide-react';

interface CountryPickerProps {
  value: string;
  onChange: (countryId: string) => void;
}

export default function CountryPicker({ value, onChange }: CountryPickerProps): React.JSX.Element {
  const { countries, isLoading, error } = useCountries();

  if (isLoading) {
    return <CountryPickerSkeleton />;
  }

  if (error) {
    return (
      <div className="country-picker country-picker--error" role="alert">
        <span>Failed to load countries</span>
      </div>
    );
  }

  return (
    <div className="country-picker" role="radiogroup" aria-label="Select country">
      {countries.map((country) => {
        const isSelected = value === country.id;

        return (
          <button
            key={country.id}
            type="button"
            role="radio"
            aria-checked={isSelected}
            aria-label={country.name}
            className={`country-picker__item ${isSelected ? 'country-picker__item--selected' : ''}`}
            onClick={() => onChange(country.id)}
          >
            <img
              className="country-picker__flag"
              src={`/flags/${country.locale}.svg`}
              alt={`${country.name} flag`}
            />
            <span className="country-picker__name">{country.name}</span>
            {isSelected && (
              <span className="country-picker__check">
                <Check size={14} />
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
